var exports = {
  "U": "sidePanel__FOnsnZ",
};

module.exports = exports;
